import { useQuery } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { CompanyFilters } from 'types/Company';
import { PersonsService } from '../services';

export const useCompaniesList = (options?: {
	skipUntilApplyFilters?: boolean;
	initialFilters?: CompanyFilters;
}) => {
	const [filters, setFilters] = useState<CompanyFilters | undefined>(
		options?.initialFilters,
	);

	const { data, isLoading } = useQuery({
		queryKey: [filters],
		refetchOnWindowFocus: false,
		queryFn: () => PersonsService.getPersons(filters),
		enabled: !options?.skipUntilApplyFilters || !!filters,
	});

	const applyFilters = useCallback((newFilters: CompanyFilters) => {
		setFilters(newFilters);
	}, []);

	return {
		companies: data?.content || [],
		loading: isLoading,
		applyFilters,
	};
};
